import { render, staticRenderFns } from "./VesselMarker.vue?vue&type=template&id=2b2c3978&scoped=true&"
import script from "./VesselMarker.vue?vue&type=script&lang=js&"
export * from "./VesselMarker.vue?vue&type=script&lang=js&"
import style0 from "./VesselMarker.vue?vue&type=style&index=0&id=2b2c3978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c3978",
  null
  
)

export default component.exports